import { useQuery } from '@tanstack/react-query';
import { Action, Subject } from '@erp/authz';
import type { ListAssigneeFacetsInput } from '@erp/rpc';
import { orpc } from 'src/api/rpc/client';
import { useCan } from 'src/hooks/useCan';

/** Distinct assignees for the queue picker (type / status / outcome). */
export function useTaskAssigneeFacets(
  input: ListAssigneeFacetsInput,
  options?: { enabled?: boolean },
) {
  const [canReadTasks, { isError: isAuthzError }] = useCan(
    Action.Read,
    Subject.Task,
  );
  const query = useQuery({
    ...orpc.tasks.listAssigneeFacets.queryOptions({ input }),
    enabled: (options?.enabled ?? true) && canReadTasks,
    staleTime: 30_000,
  });
  return {
    data: query.data,
    isSuccess: query.isSuccess,
    isError: query.isError,
    isAuthzError,
  };
}
